import React, { useEffect, useState } from "react";
import { doHealthCheck } from "services/apiMiddleware";

const HealthCheck = () => {
  const [health, setHealth] = useState();
  useEffect(() => {
    const check = async () => {
      const response = await doHealthCheck();
      setHealth(response);
    };
    check();
  }, []);

  return <div>Healthcheck response: {JSON.stringify(health)}</div>;
};

export default HealthCheck;
